import moment from 'moment'
import dataStorage from 'dataStorage'
import { getLogUrl } from 'api/api'
import { postData } from 'api/request'
import { v4 as uuidv4 } from 'uuid';
import CryptoJS from 'react-native-crypto-js';

function sendLogToServer(message, type = 'info') {
    try {
        let msg = typeof message === 'object' ? JSON.stringify(message) : message;
        const currentTime = moment().format('DD/MM/YYYY HH:mm:ss');
        msg = `MAGPIE_ONBOARDING - ${currentTime} - ${dataStorage.enviroment} - ${(dataStorage.env + '').toUpperCase()} - ${dataStorage.registerEmail} - ${msg}`;
        const key = uuidv4();
        const encrypMsg = CryptoJS.AES.encrypt(msg, key).toString();
        const logData = {
            data: encrypMsg,
            id: key,
            type
        }
        postData(getLogUrl(), logData)
    } catch (error) {
        console.error('SEND LOG ERROR: ', error);
    }
}

const error = (...arg) => {
    console.error(...arg);
    sendLogToServer(...arg, 'error');
}

const warn = (...arg) => {
    console.warn(...arg);
    sendLogToServer(...arg, 'warning');
}

const log = (...arg) => {
    sendLogToServer(...arg, 'info');
}

const logger = {
    error,
    warn,
    log
}

export default logger
